// src/services/tenantUsersApi.js
import { getJson, patchJson } from './http';
export async function listTenantUsers(tenant) {
  return getJson(`/api/tenants/${tenant}/users`);
}
export async function setUserActive(tenant, userId, active) {
  return patchJson(`/api/tenants/${tenant}/users/${userId}`, { active: active ? 1 : 0 });
}
export async function getTenantUser(tenant, userId) {
  return getJson(`/api/tenants/${tenant}/users/${userId}`);
}
export async function updateTenantUser(tenant, userId, body) {
  return patchJson(`/api/tenants/${tenant}/users/${userId}`, body);
}